export const COLORS = { red: "#E53935", green: "#2EAD4B", yellow: "#FBC02D", blue: "#1E88E5" };
export const START = { red: 0, green: 13, yellow: 26, blue: 39 };
export const SAFE = new Set([0, 13, 26, 39, 8, 21, 34, 47]);
export const FINISH = 56;

const seg = (fn, from, to) => {
  const out = [];
  const step = from <= to ? 1 : -1;
  for (let i = from; step > 0 ? i <= to : i >= to; i += step) out.push(fn(i));
  return out;
};

// 52 shared squares as [row, col] on a 15x15 grid, clockwise from red's start.
export const TRACK = [
  ...seg((c) => [6, c], 1, 5), ...seg((r) => [r, 6], 5, 0), [0, 7], [0, 8], ...seg((r) => [r, 8], 1, 5),
  ...seg((c) => [6, c], 9, 14), [7, 14], [8, 14], ...seg((c) => [8, c], 13, 9), ...seg((r) => [r, 8], 9, 14),
  [14, 7], [14, 6], ...seg((r) => [r, 6], 13, 9), ...seg((c) => [8, c], 5, 0), [7, 0], [6, 0],
];

export const HOME = {
  red: seg((c) => [7, c], 1, 5), green: seg((r) => [r, 7], 1, 5),
  yellow: seg((c) => [7, c], 13, 9), blue: seg((r) => [r, 7], 13, 9),
};

export const HOUSE = { red: [0, 0], green: [0, 9], yellow: [9, 9], blue: [9, 0] };
const SLOTS = [[1.5, 1.5], [1.5, 3.5], [3.5, 1.5], [3.5, 3.5]];
const CENTER = { red: [7, 6.4], green: [6.4, 7], yellow: [7, 7.6], blue: [7.6, 7] };

// Returns [row, col] (cell centre units) for a piece.
export const pieceCell = (color, p, idx) => {
  if (p === -1) {
    const [r0, c0] = HOUSE[color];
    return [r0 + SLOTS[idx][0], c0 + SLOTS[idx][1]];
  }
  if (p >= FINISH) return CENTER[color];
  const [r, c] = p <= 50 ? TRACK[(START[color] + p) % 52] : HOME[color][p - 51];
  return [r + 0.5, c + 0.5];
};

export const targetOf = (p, die) => (p === -1 ? 0 : p + die);
